import { Wallet, Building2, CreditCard, Banknote } from "lucide-react";
import { fmtTRY } from "@/lib/api";

const cards = [
  { key: "toplam", label: "Toplam Bakiye", icon: Wallet, accent: "indigo", featured: true },
  { key: "banka", label: "Banka", icon: Building2, accent: "sky" },
  { key: "pos", label: "POS", icon: CreditCard, accent: "violet" },
  { key: "nakit", label: "Nakit", icon: Banknote, accent: "emerald" },
];

const styles = {
  indigo: "bg-indigo-600 text-white",
  sky: "bg-white border border-slate-200",
  violet: "bg-white border border-slate-200",
  emerald: "bg-white border border-slate-200",
};

const iconStyles = {
  indigo: "bg-white/20 text-white",
  sky: "bg-sky-50 text-sky-600",
  violet: "bg-violet-50 text-violet-600",
  emerald: "bg-emerald-50 text-emerald-600",
};

export default function BalanceOverview({ totals, loading }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
      {cards.map((c) => {
        const Icon = c.icon;
        const value = totals[c.key] || 0;
        return (
          <div
            key={c.key}
            data-testid={`balance-card-${c.key}`}
            className={`rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow duration-200 ${styles[c.accent]}`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`text-xs uppercase tracking-[0.18em] font-semibold ${
                  c.featured ? "text-indigo-100" : "text-slate-500"
                }`}
              >
                {c.label}
              </span>
              <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${iconStyles[c.accent]}`}>
                <Icon className="h-4 w-4" />
              </div>
            </div>
            <div
              className={`mt-4 text-2xl sm:text-3xl font-bold tracking-tight ${
                c.featured ? "text-white" : "text-slate-900"
              }`}
            >
              {loading ? "…" : fmtTRY(value)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
